export default __webpack_public_path__ + "static/social-bece16b532af757b1ed2f9a4b1fd5ede.png";